import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Button, Form, Select, DatePicker, Spin, Table } from "antd";
import { useLocation } from "react-router-dom";
import { ReadCookie } from "../../utils/readCookie";
import numeral from "numeral";
import moment from "moment";
import logo from "../../assets/images/logo.png";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import "../ProducList/productList.css";
import { TabTitle } from "../../utils/GeneralFunction.js";
import { useDownloadExcel } from "react-export-table-to-excel";
import { getAllActiveRegion, getAllActiveSaleperson } from "../../redux/actions/getAllActive.js";
import { getGender } from "../../redux/actions/gender.action.js";
import { getspecialtyByBookingReport } from "../../redux/actions/specialtyByBookingReport.action.js";
import "./specialtyByBooking.css"

const SpecialtyByBookingReport = ({ token }) => {
  TabTitle("Specialty By Booking report")
  const { specialtyByBooking, salePersonNew, gender, RegionNew } = useSelector((state) => state);
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  var date = moment();
  const [dateTypeId, setDateTypeId] = useState("spring");
  const [monthId, setMonthId] = useState(date.format("MM"));
  const [yearId, setYearId] = useState(date.format("Y"));
  const [formState, setFormState] = useState({});
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);


  const { onDownload: onDownloadReport1 } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Specialty By Booking report",
    sheet: "Sheet 1",
  });

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();

  const generateMonthColumns = (months, prefix) =>
    months.map((month) => ({
      title: month.slice(0, 3).toUpperCase(),
      dataIndex: `${month.toLowerCase()}_${prefix}`,
      key: `${month.toLowerCase()}_${prefix}`,
      className: " b_left",
      align: "right",
      render: (text) => `$${numeral(text).format("0,0")}`,
    }));

  const generateSeasonColumns = (season, prefix) => {
    const months = season === "spring"
      ? ["january", "february", "march", "april", "may", "june"]
      : ["july", "august", "september", "october", "november", "december"];

    return [
      ...generateMonthColumns(months, prefix),
      {
        title: "Total",
        dataIndex: `${season}_${prefix}`,
        key: `${season}_${prefix}`,
        className: " b_left",
        align: "right",
        render: (text) => `$${numeral(text).format("0,0")}`,
      },
      {
        title: "Running Total",
        dataIndex: `running_total_${season}_${prefix}`,
        key: `running_total_${season}_${prefix}`,
        className: " b_left",
        align: "right",
        render: (text) => `$${numeral(text).format("0,0")}`,

      },
    ]
  };


  const isInSeason = (monthName, season) => {
    const springMonths = ["January", "February", "March", "April", "May", "June"];
    const fallMonths = ["July", "August", "September", "October", "November", "December"];

    if (season === "spring") {
      return springMonths.includes(monthName);
    } else {
      return fallMonths.includes(monthName);
    }
  };

  const allYearsLy = (specialtyByBooking?.payload?.data || [])
    .map(d => parseInt(d.year_ly, 10))
    .filter(year => !isNaN(year));
  const latestLYYear = allYearsLy.length ? Math.max(...allYearsLy) : null;

  const allYearsTy = (specialtyByBooking?.payload?.data || [])
    .map(d => parseInt(d.year_ty, 10))
    .filter(year => !isNaN(year));
  const latestTYYear = allYearsTy.length ? Math.max(...allYearsTy) : null;




  const condition = specialtyByBooking?.payload?.data[0]?.condition === "spring" ? "spring" : "fall";

  const columns1 = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
    },
    {
      title: "BOOK SEASON",
      className: "b_left",
      render: (_, record) => {
        const month = record.month_name_ly?.trim();
        const year = parseInt(record.year_ly, 10);

        if (!month || !year || !latestLYYear) return "-";

        return (year === latestLYYear && isInSeason(month, condition))
          ? "IN-SEASON"
          : "PRE-BOOK";
      }
    },
    {
      title: "BOOK YEAR",
      dataIndex: "year_ly",
      key: "year_ly",
      className: " b_left",
    },
    {
      title: "BOOK MONTH",
      dataIndex: "month_name_ly",
      key: "month_name_ly",
      className: " b_left",
    },
    {
      title: "LY",
      children: [
        {
          title: condition.toUpperCase(),
          children: generateSeasonColumns(condition, "ly"),
        },
      ],
    },
  ];

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
    },
    {
      title: "BOOK SEASON",
      className: "b_left",
      render: (_, record) => {
        const month = record.month_name_ty?.trim();
        const year = parseInt(record.year_ty, 10);

        if (!month || !year || !latestTYYear) return "-";

        return (year === latestTYYear && isInSeason(month, condition))
          ? "IN-SEASON"
          : "PRE-BOOK";
      }
    },
    {
      title: "BOOK YEAR",
      dataIndex: "year_ty",
      key: "year_ty",
      className: " b_left",
    },
    {
      title: "BOOK MONTH",
      dataIndex: "month_name_ty",
      key: "month_name_ty",
      className: " b_left",
    },
    {
      title: "TY",
      children: [
        {
          title: condition.toUpperCase(),
          children: generateSeasonColumns(condition, "ty"),
        },
      ],
    },
    {
      title: "TY/LY",
      className: " b_left",
      align: "right",
      render: (text, _, index) => {
        const tyData = transformData(specialtyByBooking?.payload?.data || [], "ty");
        const lyData = transformData(specialtyByBooking?.payload?.data || [], "ly");

        const mergedTy = tyData?.map(t => {
          const match = lyData?.find(l =>
            l.condition === t.condition &&
            l.month_name_ly.trim() === t.month_name_ty.trim() &&
            parseInt(t.year_ty) - 1 === parseInt(l.year_ly)
          );

          const isSpring = t.condition === "spring";
          const tyVal = isSpring ? t.running_total_spring_ty : t.running_total_fall_ty;
          const lyVal = match
            ? (isSpring ? match.running_total_spring_ly : match.running_total_fall_ly)
            : 0;

          // New key for column rendering later
          return {
            ...t,
            // [`${t.condition}_pct_change`]: lyVal ? ((tyVal / lyVal) - 1) * 100 : 0
            [`pct_change`]: lyVal ? ((tyVal / lyVal) - 1) * 100 : 0
          };
        });
        console.log({ mergedTy: index });

        return numeral(mergedTy[index]?.pct_change).format("0,0.00") + "%"
      },

    }
  ];


  useEffect(() => {
    dispatch(getAllActiveSaleperson(token, menuId));
    dispatch(getGender(token, menuId));
    dispatch(getAllActiveRegion(token, menuId));
  }, [token]);


  useEffect(() => {
    let year = yearId;
    let month = monthId;
    let currentYearStartDate = moment().startOf("year").format("MM/DD/YYYY");
    let currentYearEndDate = moment().endOf("year").format("MM/DD/YYYY");
    let lastYearStartDate = moment()
      .startOf("year")
      .subtract(1, "year")
      .format("MM/DD/YYYY");
    let lastYearEndDate = moment()
      .endOf("year")
      .subtract(1, "year")
      .format("MM/DD/YYYY");
    if (dateTypeId === "spring") {
      currentYearStartDate = "01" + "/" + "01" + "/" + year;
      currentYearEndDate = "06" + "/" + "30" + "/" + year;
      lastYearStartDate = "01" + "/" + "01" + "/" + (year - 1);
      lastYearEndDate = "06" + "/" + "30" + "/" + (year - 1);
    } else if (dateTypeId === "fall") {
      currentYearStartDate = "07" + "/" + "01" + "/" + year;
      currentYearEndDate = "12" + "/" + "31" + "/" + year;
      lastYearStartDate = "07" + "/" + "01" + "/" + (year - 1);
      lastYearEndDate = "12" + "/" + "31" + "/" + (year - 1);
    }
    const newState = {
      cy_start_date: currentYearStartDate,
      cy_end_date: currentYearEndDate,
      ly_start_date: lastYearStartDate,
      ly_end_date: lastYearEndDate,
    };
    setFormState(newState);
  }, [dateTypeId, monthId, yearId]);

  useEffect(() => {
    if (dateTypeId === "mtd") {
      setMonthId(moment().format("MM"));
    }
  }, [dateTypeId]);


  const onFinish = async () => {
    setLoading(true);
    await form.validateFields().then((values) => {
      console.log("first", values)
      dispatch(getspecialtyByBookingReport(token, formState, values, dateTypeId)).then((res) => {
        if (res.type === "GET_SPECIALTY_BY_BOOKING_REPORT_SUCCESS") {
          setLoading(false);
        }
      });
    }).catch((error) => {
      setLoading(false);
    })
  }

  const monthNameToNumber = {
    January: 1,
    February: 2,
    March: 3,
    April: 4,
    May: 5,
    June: 6,
    July: 7,
    August: 8,
    September: 9,
    October: 10,
    November: 11,
    December: 12
  };

  const sumMonths = (record, months, suffix) =>
    months.reduce((sum, month) => sum + (parseFloat(record[`${month}_${suffix}`]) || 0), 0);

  const transformData = (data, suffix) => {
    let runningSpring = 0;
    let runningFall = 0;

    return data
      .filter((d) => d[`year_${suffix}`] !== "2000")
      .sort((a, b) => {
        const yearA = parseInt(a[`year_${suffix}`], 10);
        const yearB = parseInt(b[`year_${suffix}`], 10);
        const monthA = monthNameToNumber[a[`month_name_${suffix}`].trim()];
        const monthB = monthNameToNumber[b[`month_name_${suffix}`].trim()];
        return yearA !== yearB ? yearA - yearB : monthA - monthB;
      })
      .map((item) => {
        const springMonths = ["january", "february", "march", "april", "may", "june"];
        const fallMonths = ["july", "august", "september", "october", "november", "december"];

        const spring = sumMonths(item, springMonths, suffix);
        const fall = sumMonths(item, fallMonths, suffix);

        runningSpring += spring;
        runningFall += fall;

        return {
          ...item,
          [`spring_${suffix}`]: spring,
          [`fall_${suffix}`]: fall,
          [`running_total_spring_${suffix}`]: runningSpring,
          [`running_total_fall_${suffix}`]: runningFall,
        };
      });
  };


  console.log(transformData(specialtyByBooking?.payload?.data || [], "ty"), 'ty');
  console.log(transformData(specialtyByBooking?.payload?.data || [], "ly"), 'ly');


  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <div className="container-fluid">

        <div className="row">
          <div className="col">
            <div className="report-wrapper-main header_class">
              <div className="row justify-content-between pb-0">
                <div className="col-3 d-flex align-items-start  box-space">
                  <div className="logobrand">
                    <img id="ImgLogo" alt="logo" src={logo} />
                  </div>
                </div>

                <div className="col-3 box-space right-content-header text-right">
                  <div className=" d-flex justify-content-end">
                    <div className=" d-flex justify-content-end printing_class">
                      <div className="print_icon printing_class">
                        <i
                          id="Image1"
                          title="Print"
                          alt="Print"
                          className="fa-solid fa-print printing_class"
                          onClick={handlePrint}
                        ></i>
                      </div>
                      <div className="print_icon printing_class">
                        {specialtyByBooking?.payload?.data ? (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            onClick={onDownloadReport1}
                            style={{
                              borderWidth: "0px",
                              height: "14px",
                              cursor: "pointer",
                            }}
                          />
                        ) : (
                          <input
                            type="image"
                            name="ImgExcel"
                            alt="Export to excel"
                            id="ImgExcel"
                            title="Export to excel"
                            src={xlsx}
                            style={{ borderWidth: "0px", height: "14px" }}
                          />
                        )}
                      </div>
                    </div>
                    <span style={{ fontWeight: "bolder" }}>
                      Specialty By Booking report
                      <br />
                      Rpt # 006
                      <br />
                      Login as:
                      <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                        {" "}
                        {userName}
                      </span>

                    </span>
                  </div>
                </div>
              </div>
              <div className="row pb-2">
                <div className="col">
                  <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                  >
                    <div className="main_form row">
                      <div className=" col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Condition:
                          </label>
                          <div style={{ marginBottom: "-2px" }} className=" w-100">
                            <Form.Item
                              name="dateTypeId"
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                className={"select_Inputs"}
                                defaultValue={dateTypeId}
                                value={dateTypeId}
                                onChange={(a) => {
                                  setDateTypeId(a);
                                  // setYearId(date.format("Y"));
                                }}
                              >
                                <Option key={"spring"} value={"spring"}>
                                  Spring
                                </Option>
                                <Option key={"fall"} value={"fall"}>
                                  Fall
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="gender_id" className="labels width30">
                            Year:
                          </label>
                          <div style={{ marginBottom: "2px" }} className=" w-100">
                            <DatePicker
                              size="small"
                              className="filter-fields full_date"
                              value={moment(yearId)}
                              defaultValue={moment(yearId)}
                              onChange={(e) =>
                                setYearId(moment(e).format("YYYY"))
                              }
                              picker="year"
                            />

                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="" className="labels width30">Sale Person</label>
                          <div style={{ marginBottom: "-5px" }} className=" w-100">
                            <Form.Item
                              name="salePersonName"
                              initialValue={"All"}
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                className="filter-fields"
                                loading={salePersonNew?.loading}
                                defaultValue="All"
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {salePersonNew?.payload?.data.map((item) => {
                                  return (
                                    <Option
                                      defaultValue={"All"}
                                      key={item.sales_person_id}
                                      value={item.sales_person_id}
                                    >
                                      {item.salesperson_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="" className="labels width30">Gender</label>
                          <div style={{ marginBottom: "-5px" }} className=" w-100">
                            <Form.Item
                              name="genderID"
                              initialValue={"All"}
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                // onChange={(e) => setGenderID(e)}
                                className="filter-fields"
                                loading={gender?.loading}
                                defaultValue="All"
                                // value={genderID}
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {gender?.payload?.data.map((item) => {
                                  return (
                                    <Option
                                      defaultValue={"All"}
                                      key={item.gender_id}
                                      value={item.gender_id}
                                    >
                                      {item.gender_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div className=" d-flex flex-row align-items-baseline">
                          <label htmlFor="" className="labels width30">Region</label>
                          <div className=" w-100">
                            <Form.Item
                              name="regionID"
                              initialValue={"All"}
                              className="formFullWidth"
                            >
                              <Select
                                allowClear
                                size="small"
                                showSearch
                                optionFilterProp="children"
                                defaultValue="All"
                                // onChange={(e) => setRegionID(e)}
                                className="filter-fields"
                                loading={RegionNew?.loading}
                                // value={regionID}
                                filterSort={(optionA, optionB) =>
                                  optionB?.value !== null ?
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase()) : ''
                                }
                              >
                                <Option value={null}>All</Option>
                                {RegionNew?.payload?.data.map((item) => {
                                  return (
                                    <Option
                                      defaultValue={"All"}
                                      key={item.region_id}
                                      value={item.region_id}
                                    >
                                      {item.region_name}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4">
                        <div style={{ marginTop: "0px", display: "flex", justifyContent: "end" }} >
                          <Button type="primary" htmlType="submit" className='submit-btn-btm m-0' disabled={loading}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div className="table_content"
        style={{ width: 'fit-content', maxWidth: "100%" }}
        ref={tableRef}
      >
        <div>
          {loading ? (
            <div className="d-flex align-items-center justify-content-center spin-style mt-3">
              <Spin />
            </div>
          ) : specialtyByBooking?.payload?.data.length ? (
            <>
              <div className="row"
              // style={{ display: 'flex', gap: '60px', }}
              >
                {/* This Year Table */}
                <div style={{ flex: 1 }} className="col-7">
                  <h3 style={{ borderBottom: "1px solid black", paddingBottom: "1px", display: "inline-block", marginBottom: "0px" }}>This Year</h3>
                  <Table
                    style={{ fontSize: '10.3px' }}
                    className="test04 mt-3 sales_target_report_table sales_report_res_table sales_target_report_table_dashboard speciality_state footer-bg "
                    size="small"
                    pagination={false}
                    bordered
                    columns={columns}
                    scroll={{ x: 'max-content' }}
                    dataSource={transformData(specialtyByBooking?.payload?.data || [], "ty")}
                    summary={(pageData) => {
                      const isSpring = specialtyByBooking?.payload?.data[0]?.condition === "spring";
                      const planRow = specialtyByBooking?.payload?.data?.find(item => item.year_ty === "2000");
                      const format = (num) => numeral(num).format("0,0");

                      const springMonths = ["january", "february", "march", "april", "may", "june"];
                      const fallMonths = ["july", "august", "september", "october", "november", "december"];

                      const activeMonths = isSpring ? springMonths : fallMonths;

                      const getMonthTotal = (month, suffix = "_ty") =>
                        pageData.reduce((sum, item) => sum + parseFloat(item[`${month}${suffix}`] || 0), 0);

                      const monthlyTotals = activeMonths.map((month) => getMonthTotal(month));
                      const lyTotal = monthlyTotals.reduce((a, b) => a + b, 0);

                      const planMonthlyTotals = activeMonths.map((month) =>
                        parseFloat(planRow?.[`plan_${month}_ty`] || 0)
                      );
                      const planTotal = planMonthlyTotals.reduce((a, b) => a + b, 0);

                      const differenceTotals = monthlyTotals.map((val, i) => val - planMonthlyTotals[i]);
                      const differenceTotal = lyTotal - planTotal;

                      return (
                        <>
                          <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3} />
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>
                                SHIPPED MONTH:
                              </p>
                            </Table.Summary.Cell>
                            {monthlyTotals.map((total, index) => (
                              <Table.Summary.Cell key={index}>
                                <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(total)}</p>
                              </Table.Summary.Cell>
                            ))}

                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(lyTotal)}</p>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                          </Table.Summary.Row>

                          <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3} />
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>PLAN:</p>
                            </Table.Summary.Cell>
                            {planMonthlyTotals.map((total, index) => (
                              <Table.Summary.Cell key={`plan-${index}`}>
                                <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(total)}</p>
                              </Table.Summary.Cell>
                            ))}
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(planTotal)}</p>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                          </Table.Summary.Row>

                          <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3} />
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>DEFICIT TO PLAN:</p>
                            </Table.Summary.Cell>
                            {differenceTotals.map((total, index) => (
                              <Table.Summary.Cell key={`diff-${index}`}>
                                <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(total)}</p>
                              </Table.Summary.Cell>
                            ))}
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(differenceTotal)}</p>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell />
                          </Table.Summary.Row>
                        </>
                      );
                    }}
                  />
                </div>

                {/* Last Year Table */}
                <div style={{ flex: 1 }} className="col-7">
                  <h3 style={{ borderBottom: "1px solid black", paddingBottom: "1px", display: "inline-block", marginBottom: "0px" }}>Last Year</h3>
                  <Table
                    style={{ fontSize: '10.3px' }}
                    className="test04 mt-3 sales_target_report_table sales_report_res_table sales_target_report_table_dashboard speciality_state footer-bg"
                    size="small"
                    pagination={false}
                    bordered
                    columns={columns1}
                    scroll={{ x: 'max-content' }}
                    dataSource={transformData(specialtyByBooking?.payload?.data || [], "ly")}
                    summary={(pageData) => {
                      const isSpring = specialtyByBooking?.payload?.data[0]?.condition === "spring";
                      const planRow = specialtyByBooking?.payload?.data?.find(item => item.year_ty === "2000");

                      const format = (num) => numeral(num).format("0,0");

                      const springMonths = ["january", "february", "march", "april", "may", "june"];
                      const fallMonths = ["july", "august", "september", "october", "november", "december"];
                      const activeMonths = isSpring ? springMonths : fallMonths;

                      const getMonthTotal = (month, suffix = "_ly") =>
                        pageData.reduce((sum, item) => sum + parseFloat(item[`${month}${suffix}`] || 0), 0);

                      const monthlyTotals = activeMonths.map((month) => getMonthTotal(month));
                      const lyTotal = monthlyTotals.reduce((a, b) => a + b, 0);

                      const planMonthlyTotals = activeMonths.map((month) =>
                        parseFloat(planRow?.[`plan_${month}_ly`] || 0)
                      );
                      const planTotal = planMonthlyTotals.reduce((a, b) => a + b, 0);

                      const differenceTotals = monthlyTotals.map((val, i) => val - planMonthlyTotals[i]);
                      const differenceTotal = lyTotal - planTotal;

                      return (
                        <>
                          {/* Row 1 - SHIPPED MONTH */}
                          <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3} />
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>SHIPPED MONTH:</p>
                            </Table.Summary.Cell>
                            {monthlyTotals.map((total, index) => (
                              <Table.Summary.Cell key={`shipped-${index}`}>
                                <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(total)}</p>
                              </Table.Summary.Cell>
                            ))}
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(lyTotal)}</p>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                          </Table.Summary.Row>

                          {/* Row 2 - PLAN */}
                          <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3} />
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>PLAN:</p>
                            </Table.Summary.Cell>
                            {planMonthlyTotals.map((total, index) => (
                              <Table.Summary.Cell key={`plan-${index}`}>
                                <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(total)}</p>
                              </Table.Summary.Cell>
                            ))}
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(planTotal)}</p>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                          </Table.Summary.Row>

                          {/* Row 3 - SHIPPED - PLAN */}
                          <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3} />
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>DEFICIT TO PLAN:</p>
                            </Table.Summary.Cell>
                            {differenceTotals.map((total, index) => (
                              <Table.Summary.Cell key={`diff-${index}`}>
                                <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(total)}</p>
                              </Table.Summary.Cell>
                            ))}
                            <Table.Summary.Cell>
                              <p className="totalquantity aligntext" style={{ textAlign: "right" }}>${format(differenceTotal)}</p>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell />
                          </Table.Summary.Row>
                        </>
                      );
                    }}

                  />
                </div>
              </div>

            </>
          ) : (
            <div
              style={{
                backgroundColor: '#CCCCCC',
                borderWidth: '1pt',
                borderStyle: 'Dashed',
                fontWeight: 'bold',
                height: '25px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              No record(s)
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SpecialtyByBookingReport;